export const GET_CRBWP_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_CRBWP_REQUEST";
export const GET_CRBWP_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_CRBWP_SUCCESS";
export const GET_CRBWP_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_CRBWP_FAILURE";
